import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import GeneratedLinks from "@/components/GeneratedLinks";

export default function Lightbox({ image, onOpenChange }) {
  return (
    <Dialog open={!!image} onOpenChange={(o) => !o && onOpenChange(null)}>
      <DialogContent className="max-w-4xl p-0 border-0 bg-transparent shadow-none" data-testid="lightbox">
        <DialogTitle className="sr-only">Image share links</DialogTitle>
        <DialogDescription className="sr-only">Preview the image and copy its embed and share links.</DialogDescription>
        {image && <GeneratedLinks image={image} />}
      </DialogContent>
    </Dialog>
  );
}
